import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { Field, slugify } from "./_shared";

/* ---------------------------------------------------------------------------
 * Add-pub dialog (only for Pub Group parent).
 * ------------------------------------------------------------------------- */
export function AddPubDialog({ open, onOpenChange, clientId, onCreated }) {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [town, setTown] = useState("");
  const [color, setColor] = useState("#0038FF");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setName(""); setSlug(""); setTown(""); setColor("#0038FF"); } }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/pubs", {
        client_id: clientId,
        name,
        slug: slug || slugify(name),
        primary_color: color,
        town: town || null,
      });
      toast.success(`Pub "${name}" added`);
      onCreated?.(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-md max-w-md" data-testid="add-pub-dialog">
        <DialogHeader>
          <DialogTitle>Add a pub to this Group</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Pub name">
            <Input required value={name} onChange={(e) => { setName(e.target.value); if (!slug) setSlug(slugify(e.target.value)); }} data-testid="ap-name" className="h-10 rounded-sm border-zinc-300" />
          </Field>
          <Field label="Town">
            <Input value={town} onChange={(e) => setTown(e.target.value)} data-testid="ap-town" className="h-10 rounded-sm border-zinc-300" />
          </Field>
          <Field label="Slug">
            <Input required value={slug} onChange={(e) => setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ""))} data-testid="ap-slug" className="h-10 rounded-sm border-zinc-300 font-mono text-sm" />
          </Field>
          <Field label="Brand colour">
            <div className="flex items-center gap-2">
              <input type="color" value={color} onChange={(e) => setColor(e.target.value.toUpperCase())} className="h-10 w-14 rounded-sm border border-zinc-300 cursor-pointer p-0.5" />
              <Input value={color} onChange={(e) => setColor(e.target.value)} className="h-10 rounded-sm border-zinc-300 font-mono uppercase text-sm" />
            </div>
          </Field>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={saving} className="rounded-sm">Cancel</Button>
            <Button type="submit" disabled={saving} data-testid="ap-submit" className="rounded-sm bg-zinc-950 hover:bg-black text-white">{saving ? "Adding…" : "Add pub"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
